import { Component } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';
import { EmailStepComponent } from '../register-steps/email-step/email-step.component';
import { RegistrationStepComponent } from '../register-steps/registration-step/registration-step.component';
import { TermsStepComponent } from '../register-steps/terms-step/terms-step.component';
import { UserPrivacyStepComponent } from '../register-steps/user_privacy-step/user_privacy-step.component';
import { DialogUtilsService } from '../utils/dialog-utility.service';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { PassConsentMissingComponent } from '../register-steps/pass_consent_missing-step/pass_consent_missing.component';
@Component({
  selector: 'app-register-flow',
  templateUrl: './register-flow.component.html',
  styleUrls: ['./register-flow.component.scss'],
  imports: [
    CommonModule, 
    EmailStepComponent,
    RegistrationStepComponent,
    TermsStepComponent,
    UserPrivacyStepComponent,
    PassConsentMissingComponent
  ],
})
export class RegisterFlowComponent {
  constructor(
    private translocoService: TranslocoService,
    private dialogUtilsService: DialogUtilsService,
    private dialogRef: MatDialogRef<any>,
  
  ) {}
  
  changeLang(lang: string) {
    this.translocoService.setActiveLang(lang);
  }
  currentStep: 'email' | 'registration' | 'terms' | 'privacy' | 'passconsent' = 'email';
  userEmail: string = '';
  userVeevaInfo: any;
  previousStep: string = '';
  goTo(step: 'email' | 'registration' | 'terms' | 'privacy' | 'passconsent', data?: any) {
    this.previousStep = this.currentStep;
    if(step === 'registration' && data) {
      this.userEmail = data;
    }
    if (step === 'registration') {
      // The registration component will handle restoring its own state
    }
    this.currentStep = step;
    this.resizeDialogForCurrentStep(step);
  }
  goBack(){
    const targetStep = this.previousStep || 'email';
    this.goTo(targetStep as 'email' | 'registration' | 'terms' | 'privacy' | 'passconsent');
  }
  private resizeDialogForCurrentStep(step: string): void {
  // Reference to the current dialog
    const dialogRef = this.dialogRef;
    if (!dialogRef) return;
    let sizePreset: 'small' | 'medium' | 'large' | 'registration' | 'passconsent' = 'medium';
    
    // Determine appropriate size based on step
    switch (step) {
      case 'registration':
        // Registration step needs more space
        sizePreset = 'registration';
        break;
      case 'passconsent':
        sizePreset = 'passconsent';
        break;
      case 'terms':
      case 'privacy':
        // These might need a bit more vertical space
        sizePreset = 'large';
        break;
      case 'email':
      default:
        // Email step can be medium/default size
        sizePreset = 'medium';
        break;
    }
    
    // Get dimensions based on the size preset
    const { width, height } = this.dialogUtilsService.calculateDialogSize();
    
    // Update dialog size
    dialogRef.updateSize(`${width}px`, `${height}px`);
    
    // Update max dimensions too if needed
    const dialogContainer = document.querySelector('.mat-mdc-dialog-container');
    if (dialogContainer) {
      if (sizePreset === 'registration' || sizePreset === 'passconsent') {
        dialogRef.updateSize(`${width}px`, `${height+100}px`);
        dialogContainer.classList.add('registration-step-dialog');
      } else {
        console.log("removing registr");
        dialogContainer.classList.remove('registration-step-dialog');
      }
    }
  }
  shouldShowCloseButton(): boolean {
    const apiVersion = JSON.parse(localStorage.getItem('ferrerSessionData'));
    return this.dialogUtilsService.shouldShowCloseButton();
  }
  goToPassconsent(data: {email: string, veevaInfo: any}): void {
    this.userEmail = data.email;
    this.userVeevaInfo = data.veevaInfo;
    console.log("user email", data.email);
    console.log("user veeva info", data.veevaInfo);
    this.goTo('passconsent');
  }
}